// extracted by mini-css-extract-plugin
export default {"button":"styles_button__KymbX","disabled":"styles_disabled__0XBZ2","white":"styles_white__jqNVT"};